export const ROUTES_TO_HIDE_STICKY_MENU = ['/login', '/register', '/play', '/404', '/403'];
export const ROUTES_TO_DISPLAY_INSTALL_APP = ['login'];
